//#region \0rolldown/runtime.js
var e = Object.create, t = Object.defineProperty, n = Object.getOwnPropertyDescriptor, r = Object.getOwnPropertyNames, i = Object.getPrototypeOf, a = Object.prototype.hasOwnProperty, o = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), s = (e, i, o, s) => {
	if (i && typeof i == "object" || typeof i == "function") for (var c = r(i), l = 0, u = c.length, d; l < u; l++) d = c[l], !a.call(e, d) && d !== o && t(e, d, {
		get: ((e) => i[e]).bind(null, d),
		enumerable: !(s = n(i, d)) || s.enumerable
	});
	return e;
}, c = (n, r, o) => (o = n == null ? {} : e(i(n)), s(r || !n || !n.__esModule || !a.call(n, "default") ? t(o, "default", {
	value: n,
	enumerable: !0
}) : o, n)), l = "CONNECT", u = /* @__PURE__ */ function(e) {
	return e.GET_STATE = "get-state", e.GET_STATE_RESPONSE = "get-state-response", e.SET_STATE = "set-state", e.ON_CHANGE = "on-change", e.RESIZE = "resize", e;
}({}), d = new (/* @__PURE__ */ c((/* @__PURE__ */ o(((e, t) => {
	var n = (() => {
		var e = Object.defineProperty, t = Object.getOwnPropertyDescriptor, n = Object.getOwnPropertyNames, r = Object.getOwnPropertySymbols, i = Object.prototype.hasOwnProperty, a = Object.prototype.propertyIsEnumerable, o = (t, n, r) => n in t ? e(t, n, {
			enumerable: !0,
			configurable: !0,
			writable: !0,
			value: r
		}) : t[n] = r, s = (e, t) => {
			for (var n in t ||= {}) i.call(t, n) && o(e, n, t[n]);
			if (r) for (var n of r(t)) a.call(t, n) && o(e, n, t[n]);
			return e;
		}, c = (t, n) => {
			for (var r in n) e(t, r, {
				get: n[r],
				enumerable: !0
			});
		}, l = (r, a, o, s) => {
			if (a && typeof a == "object" || typeof a == "function") for (let c of n(a)) !i.call(r, c) && c !== o && e(r, c, {
				get: () => a[c],
				enumerable: !(s = t(a, c)) || s.enumerable
			});
			return r;
		}, u = (t) => l(e({}, "__esModule", { value: !0 }), t), d = (e, t, n) => o(e, typeof t == "symbol" ? t : t + "", n), f = {};
		c(f, {
			DEFAULT_OPTIONS: () => h,
			DEFAULT_UUID_LENGTH: () => m,
			default: () => _
		});
		var p = "5.3.2", m = 6, h = {
			dictionary: "alphanum",
			shuffle: !0,
			debug: !1,
			length: m,
			counter: 0
		}, g = class {
			constructor(e = {}) {
				d(this, "counter"), d(this, "debug"), d(this, "dict"), d(this, "version"), d(this, "dictIndex", 0), d(this, "dictRange", []), d(this, "lowerBound", 0), d(this, "upperBound", 0), d(this, "dictLength", 0), d(this, "uuidLength"), d(this, "_digit_first_ascii", 48), d(this, "_digit_last_ascii", 58), d(this, "_alpha_lower_first_ascii", 97), d(this, "_alpha_lower_last_ascii", 123), d(this, "_hex_last_ascii", 103), d(this, "_alpha_upper_first_ascii", 65), d(this, "_alpha_upper_last_ascii", 91), d(this, "_number_dict_ranges", { digits: [this._digit_first_ascii, this._digit_last_ascii] }), d(this, "_alpha_dict_ranges", {
					lowerCase: [this._alpha_lower_first_ascii, this._alpha_lower_last_ascii],
					upperCase: [this._alpha_upper_first_ascii, this._alpha_upper_last_ascii]
				}), d(this, "_alpha_lower_dict_ranges", { lowerCase: [this._alpha_lower_first_ascii, this._alpha_lower_last_ascii] }), d(this, "_alpha_upper_dict_ranges", { upperCase: [this._alpha_upper_first_ascii, this._alpha_upper_last_ascii] }), d(this, "_alphanum_dict_ranges", {
					digits: [this._digit_first_ascii, this._digit_last_ascii],
					lowerCase: [this._alpha_lower_first_ascii, this._alpha_lower_last_ascii],
					upperCase: [this._alpha_upper_first_ascii, this._alpha_upper_last_ascii]
				}), d(this, "_alphanum_lower_dict_ranges", {
					digits: [this._digit_first_ascii, this._digit_last_ascii],
					lowerCase: [this._alpha_lower_first_ascii, this._alpha_lower_last_ascii]
				}), d(this, "_alphanum_upper_dict_ranges", {
					digits: [this._digit_first_ascii, this._digit_last_ascii],
					upperCase: [this._alpha_upper_first_ascii, this._alpha_upper_last_ascii]
				}), d(this, "_hex_dict_ranges", {
					decDigits: [this._digit_first_ascii, this._digit_last_ascii],
					alphaDigits: [this._alpha_lower_first_ascii, this._hex_last_ascii]
				}), d(this, "_dict_ranges", {
					_number_dict_ranges: this._number_dict_ranges,
					_alpha_dict_ranges: this._alpha_dict_ranges,
					_alpha_lower_dict_ranges: this._alpha_lower_dict_ranges,
					_alpha_upper_dict_ranges: this._alpha_upper_dict_ranges,
					_alphanum_dict_ranges: this._alphanum_dict_ranges,
					_alphanum_lower_dict_ranges: this._alphanum_lower_dict_ranges,
					_alphanum_upper_dict_ranges: this._alphanum_upper_dict_ranges,
					_hex_dict_ranges: this._hex_dict_ranges
				}), d(this, "log", (...e) => {
					let t = [...e];
					if (t[0] = `[short-unique-id] ${e[0]}`, this.debug === !0 && typeof console < "u" && console !== null) {
						console.log(...t);
						return;
					}
				}), d(this, "_normalizeDictionary", (e, t) => {
					let n;
					if (e && Array.isArray(e) && e.length > 1) n = e;
					else {
						n = [], this.dictIndex = 0;
						let t = `_${e}_dict_ranges`, r = this._dict_ranges[t], i = 0;
						for (let [, e] of Object.entries(r)) {
							let [t, n] = e;
							i += Math.abs(n - t);
						}
						n = Array(i);
						let a = 0;
						for (let [, e] of Object.entries(r)) {
							this.dictRange = e, this.lowerBound = this.dictRange[0], this.upperBound = this.dictRange[1];
							let t = this.lowerBound <= this.upperBound, r = this.lowerBound, i = this.upperBound;
							if (t) for (let e = r; e < i; e++) n[a++] = String.fromCharCode(e), this.dictIndex = e;
							else for (let e = r; e > i; e--) n[a++] = String.fromCharCode(e), this.dictIndex = e;
						}
						n.length = a;
					}
					if (t) {
						let e = n.length;
						for (let t = e - 1; t > 0; t--) {
							let e = Math.floor(Math.random() * (t + 1));
							[n[t], n[e]] = [n[e], n[t]];
						}
					}
					return n;
				}), d(this, "setDictionary", (e, t) => {
					this.dict = this._normalizeDictionary(e, t), this.dictLength = this.dict.length, this.setCounter(0);
				}), d(this, "seq", () => this.sequentialUUID()), d(this, "sequentialUUID", () => {
					let e = this.dictLength, t = this.dict, n = this.counter, r = [];
					do {
						let i = n % e;
						n = Math.trunc(n / e), r.push(t[i]);
					} while (n !== 0);
					let i = r.join("");
					return this.counter += 1, i;
				}), d(this, "rnd", (e = this.uuidLength || m) => this.randomUUID(e)), d(this, "randomUUID", (e = this.uuidLength || m) => {
					if (e == null || e < 1) throw Error("Invalid UUID Length Provided");
					let t = Array(e), n = this.dictLength, r = this.dict;
					for (let i = 0; i < e; i++) {
						let e = Math.floor(Math.random() * n);
						t[i] = r[e];
					}
					return t.join("");
				}), d(this, "fmt", (e, t) => this.formattedUUID(e, t)), d(this, "formattedUUID", (e, t) => {
					let n = {
						$r: this.randomUUID,
						$s: this.sequentialUUID,
						$t: this.stamp
					};
					return e.replace(/\$[rs]\d{0,}|\$t0|\$t[1-9]\d{1,}/g, (e) => {
						let r = e.slice(0, 2), i = Number.parseInt(e.slice(2), 10);
						return r === "$s" ? n[r]().padStart(i, "0") : r === "$t" && t ? n[r](i, t) : n[r](i);
					});
				}), d(this, "availableUUIDs", (e = this.uuidLength) => Number.parseFloat(([...new Set(this.dict)].length ** e).toFixed(0))), d(this, "_collisionCache", /* @__PURE__ */ new Map()), d(this, "approxMaxBeforeCollision", (e = this.availableUUIDs(this.uuidLength)) => {
					let t = e, n = this._collisionCache.get(t);
					if (n !== void 0) return n;
					let r = Number.parseFloat(Math.sqrt(Math.PI / 2 * e).toFixed(20));
					return this._collisionCache.set(t, r), r;
				}), d(this, "collisionProbability", (e = this.availableUUIDs(this.uuidLength), t = this.uuidLength) => Number.parseFloat((this.approxMaxBeforeCollision(e) / this.availableUUIDs(t)).toFixed(20))), d(this, "uniqueness", (e = this.availableUUIDs(this.uuidLength)) => {
					let t = Number.parseFloat((1 - this.approxMaxBeforeCollision(e) / e).toFixed(20));
					return t > 1 ? 1 : t < 0 ? 0 : t;
				}), d(this, "getVersion", () => this.version), d(this, "stamp", (e, t) => {
					let n = Math.floor((t || /* @__PURE__ */ new Date()) / 1e3).toString(16);
					if (typeof e == "number" && e === 0) return n;
					if (typeof e != "number" || e < 10) throw Error(["Param finalLength must be a number greater than or equal to 10,", "or 0 if you want the raw hexadecimal timestamp"].join("\n"));
					let r = e - 9, i = Math.round(Math.random() * (r > 15 ? 15 : r)), a = this.randomUUID(r);
					return `${a.substring(0, i)}${n}${a.substring(i)}${i.toString(16)}`;
				}), d(this, "parseStamp", (e, t) => {
					if (t && !/t0|t[1-9]\d{1,}/.test(t)) throw Error("Cannot extract date from a formated UUID with no timestamp in the format");
					let n = t ? t.replace(/\$[rs]\d{0,}|\$t0|\$t[1-9]\d{1,}/g, (e) => {
						let t = {
							$r: (e) => [...Array(e)].map(() => "r").join(""),
							$s: (e) => [...Array(e)].map(() => "s").join(""),
							$t: (e) => [...Array(e)].map(() => "t").join("")
						}, n = e.slice(0, 2), r = Number.parseInt(e.slice(2), 10);
						return t[n](r);
					}).replace(/^(.*?)(t{8,})(.*)$/g, (t, n, r) => e.substring(n.length, n.length + r.length)) : e;
					if (n.length === 8) return /* @__PURE__ */ new Date(Number.parseInt(n, 16) * 1e3);
					if (n.length < 10) throw Error("Stamp length invalid");
					let r = Number.parseInt(n.substring(n.length - 1), 16);
					return /* @__PURE__ */ new Date(Number.parseInt(n.substring(r, r + 8), 16) * 1e3);
				}), d(this, "setCounter", (e) => {
					this.counter = e;
				}), d(this, "validate", (e, t) => {
					let n = t ? this._normalizeDictionary(t) : this.dict;
					return e.split("").every((e) => n.includes(e));
				});
				let t = s(s({}, h), e);
				this.counter = 0, this.debug = !1, this.dict = [], this.version = p;
				let { dictionary: n, shuffle: r, length: i, counter: a } = t;
				this.uuidLength = i, this.setDictionary(n, r), this.setCounter(a), this.debug = t.debug, this.log(this.dict), this.log(`Generator instantiated with Dictionary Size ${this.dictLength} and counter set to ${this.counter}`), this.log = this.log.bind(this), this.setDictionary = this.setDictionary.bind(this), this.setCounter = this.setCounter.bind(this), this.seq = this.seq.bind(this), this.sequentialUUID = this.sequentialUUID.bind(this), this.rnd = this.rnd.bind(this), this.randomUUID = this.randomUUID.bind(this), this.fmt = this.fmt.bind(this), this.formattedUUID = this.formattedUUID.bind(this), this.availableUUIDs = this.availableUUIDs.bind(this), this.approxMaxBeforeCollision = this.approxMaxBeforeCollision.bind(this), this.collisionProbability = this.collisionProbability.bind(this), this.uniqueness = this.uniqueness.bind(this), this.getVersion = this.getVersion.bind(this), this.stamp = this.stamp.bind(this), this.parseStamp = this.parseStamp.bind(this);
			}
		};
		d(g, "default", g);
		var _ = g;
		return u(f);
	})();
	t !== void 0 && (t.exports = n.default), typeof window < "u" && (n = n.default);
})))(), 1)).default({ length: 10 }), f = class e {
	constructor(e, t) {
		this.onMessageHandlers = [], this.message = (e, t, n) => this.crossOrigin ? this.postMessage(e, t, n) : this.customEventMessage(e, t, n), this.channelId = e ?? "DEFAULT", this.channelNodeId = `channel-node-${d.rnd()}`, this.crossOrigin = t, this.connection = new Promise((e) => {
			this.resolveConnection = e;
		}), this.boundMessageHandler = this.handleMessage.bind(this);
	}
	disconnect() {
		this.onMessageHandlers = [], window.removeEventListener(this.channelId, this.boundMessageHandler), this.connection = new Promise((e) => {
			this.resolveConnection = e;
		});
	}
	onMessage(e) {
		this.onMessageHandlers.push(e);
	}
	removeMessageHandler(e) {
		let t = this.onMessageHandlers.findIndex((t) => t === e);
		this.onMessageHandlers.splice(t, 1);
	}
	customEventMessage(e, t, n) {
		let r = new CustomEvent(this.channelId, { detail: {
			eventId: n,
			channelId: this.channelId,
			channelNodeId: this.channelNodeId,
			name: e,
			data: t
		} });
		window.dispatchEvent(r);
	}
	postMessage(e, t, n) {
		if (!this.crossOrigin?.targetOrigin) {
			console.error("A target origin was not specified.");
			return;
		}
		this.crossOrigin?.window?.postMessage({
			eventId: n,
			channelId: this.channelId,
			channelNodeId: this.channelNodeId,
			name: e,
			data: t
		}, this.crossOrigin?.targetOrigin);
	}
	async eventRequest(e, t) {
		let n = d.rnd();
		return new Promise((r) => {
			let i = (e) => {
				let { eventId: t } = e;
				n === t && (this.removeMessageHandler(i), r(e));
			};
			this.onMessage(i), this.message(e, t, n);
		});
	}
	async waitForEvent(e) {
		return new Promise((t) => {
			let n = (r) => {
				let { name: i } = r;
				e === i && (this.removeMessageHandler(n), t(r));
			};
			this.onMessage(n);
		});
	}
	handleMessage(t) {
		let n;
		if (e.isCustomEvent(t)) n = t.detail;
		else {
			if (this.crossOrigin && !this.crossOrigin.targetOrigin.includes(t.origin) && this.crossOrigin?.targetOrigin !== "*") return;
			n = t.data;
		}
		let { channelId: r, channelNodeId: i } = n;
		this.channelId === r && this.channelNodeId !== i && this.onMessageHandlers.forEach((e) => {
			e(n);
		});
	}
	static isCustomEvent(e) {
		return e.detail !== void 0;
	}
}, p = class extends f {
	connect(e) {
		return window.addEventListener(this.crossOrigin ? "message" : this.channelId, this.boundMessageHandler), this.waitForEvent(l).then((t) => {
			this.message("CONNECTION_EVENT_RESPONSE", e, t.eventId), this.resolveConnection(t);
		}), this.connection;
	}
}, m = class extends f {
	connect() {
		return window.addEventListener(this.crossOrigin ? "message" : this.channelId, this.boundMessageHandler), this.eventRequest(l).then((e) => {
			this.resolveConnection(e);
		}), this.connection;
	}
};
//#endregion
export { u as ChannelEvents, m as FollowerNode, p as LeaderNode };
